import Snippet from "../../components/Snippet/Snippet"

const List = () => {

    return <div className="container fluid pt-2" id="intro">

        <div className="container fluid py-2">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Listing items in POKE-CSS</p>
            <p className="text md">Listing items are a group of elements which are displayed in column view used represent a collection of items.</p>
        </div>

        <div className="row align-items-center">
            <div className="col md-III">
                <div className="container sm">
                    <div className="listing">
                        <div className="item"> list item </div>
                        <div className="item active"> another list item </div>
                        <div className="item">  another list item </div>
                    </div>
                </div>
            </div>
            <div className="col md-III">
                <div className="container sm">
                    <Snippet code={`<div class="listing">
    <div class="item"> list item </div>
    <div class="item active"> another list item </div>
    <div class="item">  another list item </div>
</div>`} language='html' />
                </div>
            </div>
        </div>
    </div>

}

export default List